import React, { useRef } from "react";
import flecha_s from "./assets/flecha-s.png";
import "./index.css";
import { removeHTML } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import { HeaderSkeleton } from "./skeleton";
import defaultBanner from "../../assets/academia-8-islas-hero3.jpeg";
import { useConfig } from "../../contexts/config";

/* to work on */
export const HeaderCourses = ({ moodle, lang }) => {
  const theme = useTheme();
  const { config } = useConfig();
  const header = useRef(null);
  const course = moodle.courses?.[0];
  const text = course ? removeHTML(course.summary) : null;
  const navigation = useNavigate();

  const handleNavigation = () => navigation(`/detailcourse/${course.id}`);

  return (
    <>
      {lang && (
        <div>
          <header
            ref={header}
            className="flex items-center py-10 tablet:py-16 min-h-[280px] tablet:min-h-[500px]"
            style={{
              backgroundImage: `linear-gradient(to top, ${
                theme.mode === "light" ? "#fff" : "rgb(14, 15, 28)"
              } 0%, rgba(14, 15, 28, 0.9) 40%, rgba(14, 15, 28, 0.65) 75%, rgba(0, 0, 0, 0.3) 100%), url(${defaultBanner})`,
              backgroundSize: "cover",
              backgroundPosition: "center top",
            }}
          >
            <div className="page-content-shell">
                <div className="w-full laptop:w-7/12">
                  {!course ? (
                    <HeaderSkeleton />
                  ) : (
                    <div className="flex flex-col items-start w-full">
                      <h1
                        className="font-outfit font-semibold text-white drop-shadow-md"
                        style={{
                          fontSize: "clamp(26px, 5.5vw, 54px)",
                          lineHeight: "1.15",
                          wordBreak: "break-word",
                          margin: 0,
                          padding: 0,
                        }}
                      >
                        {course.fullname}
                      </h1>
                      {text && (
                        <p
                          className="max-tablet:hidden font-outfit text-white/90 drop-shadow"
                          style={{
                            fontSize: "clamp(15px, 2vw, 17px)",
                            lineHeight: "1.6",
                            marginTop: "16px",
                            marginBottom: "0px",
                            maxWidth: "580px",
                          }}
                        >
                          {text}
                        </p>
                      )}
                      <div className="mt-5 tablet:mt-6">
                        <button
                          type="button"
                          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-[8px] font-outfit font-semibold transition-all duration-300 transform hover:shadow-lg hover:brightness-105 active:scale-95 bg-[#ECB236]"
                          style={{
                            border: "2px solid #ECB236",
                            color: "rgb(101, 72, 1)",
                            fontSize: "16px",
                            fontWeight: "600",
                          }}
                          onClick={handleNavigation}
                        >
                          <span>Comenzar estudio diario</span>
                          <svg
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
            </div>
          </header>
        </div>
      )}
    </>
  );
};
